module.exports = __webpack_public_path__ + "img/logo.76853a54.png";